module.exports = __webpack_public_path__ + "img/ai-book-white.6632f8c1.svg";